import { Theme } from "common";

export const createEditStudyFormStyles = {
  root: {
    paddingLeft: "30px",
    paddingTop: "24px",
    paddingRight: "30px",
    paddingBottom: "24px",
  },
  chip: {
    margin: "2px",
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  space: { whiteSpace: "noWrap" },
  customGridMargin: {
    marginBottom: "15px",
  },
  tabHeader: {
    backgroundColor: Theme.palette.grey[100],
  },
  customContactGridWidth: {
    width: "230px",
  },
  areaZipCodes: {
    whiteSpace: "nowrap",
  },
  contentNoWrap: {
    flexWrap: "nowrap",
  },
  scrollableContainer: {
    overflowX: "auto",
  },
  studyValidationPaper: {
    backgroundColor: Theme.palette.common.white,
    padding: "16px",
  },
  errorMessage: {
    color: "#611A15",
  },
  errorMsgGrid: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fcecea",
  },
  errorOutlineIcon: {
    verticalAlign: "sub",
    marginRight: "8px",
  },
};
